if (!customElements.get('gift-message')) {
  customElements.define(
    'gift-message',
    class GiftMessage extends HTMLElement {
      constructor() {
        super();
        this.textarea = this.querySelector('textarea');
        this.counter = this.querySelector('[data-gift-count]');
        this.updateCounter = this.updateCounter.bind(this);
        this.onFormData = this.onFormData.bind(this);
      }

      connectedCallback() {
        this.form = this.textarea.form;
        this.textarea.addEventListener('input', this.updateCounter);
        window.addEventListener('pageshow', this.updateCounter);
        if (this.form) this.form.addEventListener('formdata', this.onFormData);
        this.updateCounter();
      }

      disconnectedCallback() {
        this.textarea.removeEventListener('input', this.updateCounter);
        window.removeEventListener('pageshow', this.updateCounter);
        if (this.form) this.form.removeEventListener('formdata', this.onFormData);
      }

      updateCounter() {
        this.counter.textContent = `${this.textarea.value.length} / ${this.textarea.maxLength}`;
      }

      // A blank property would still be saved and split otherwise identical cart lines.
      onFormData(event) {
        const message = this.textarea.value.trim();
        if (message) {
          event.formData.set(this.textarea.name, message);
        } else {
          event.formData.delete(this.textarea.name);
        }
      }
    }
  );
}
